import { useContext } from "react";
import { SportsCampsContext } from "../context/sportscamps-context";

const AvailabliltyFilter = () => {
	const {
		dictionaryWords,
		setFreePlacesOnly,
		availabilityButtonActive,
		setAvailabilityButtonActive,
	} = useContext(SportsCampsContext);

	const availabilityFilterHandler = () => {
		if (availabilityButtonActive === false) {
			setFreePlacesOnly((prevState) => !prevState);
			setAvailabilityButtonActive((prevState) => !prevState);
		} else {
			setFreePlacesOnly((prevState) => !prevState);
			setAvailabilityButtonActive((prevState) => !prevState);
		}
	};

	return (
		<div className="filter-section">
			<h3>{dictionaryWords.freeSpots}</h3>
			<div>
				<button
					className={availabilityButtonActive ? "active" : ""}
					onClick={availabilityFilterHandler}
				>
					{dictionaryWords.onlyFreeSpots}
					<i className="fa fa-close"></i>
				</button>
			</div>
		</div>
	);
};

export default AvailabliltyFilter;
